const menuToggleId = "#burger-menu";
let menuToggle = document.querySelector(menuToggleId);
const is_mobile_view = () => {
    var style = window.getComputedStyle(menuToggle);
   return style.display === 'block';
}

export default is_mobile_view;